import CardStats from "../Cards/CardStats";
import { formatMoney } from "../../utils/formatters";

export default function HeaderStats({ summary, isLoading, collapsed, labels }) {
  // (2026-05-13) Req 2: el backend devuelve `moneda` nested ({codigo,simbolo,posicion}).
  // Lo pasamos directamente a formatMoney() para que el simbolo y la posicion
  // se manejen segun el catalogo. Sin moneda nested -> default VES.
  const monedaObj = summary?.moneda || null;
  const codigoEtiqueta = monedaObj?.codigo || summary?.currency || "VES";

  // (2026-06-09) Etiquetas configurables: por defecto ventas; el panel de
  // Compras pasa labels propias.
  const L = {
    neto: "TOTAL NETO GENERAL",
    facturado: "TOTAL FACTURADO",
    nc: "TOTAL NOTAS DE CRÉDITO",
    nd: "TOTAL NOTAS DE DÉBITO",
    ...(labels || {}),
  };

  const renderValue = (value) => {
    if (isLoading) {
      return (
        <i className="fas fa-spinner fa-spin text-twilight-indigo-600 text-xl"></i>
      );
    }
    return formatMoney(value, monedaObj);
  };

  return (
    <div className="pb-4">
      <div className="px-4 md:px-8 mx-auto w-full">
        <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-4">

          <CardStats
            collapsed={collapsed}
            variant="success"
            statSubtitle={`${L.neto} (${codigoEtiqueta})`}
            statTitle={renderValue(summary?.total_neto_general)}
            statIconName="fas fa-chart-line"
            statIconColor="bg-emerald-500"
          />

          <CardStats
            collapsed={collapsed}
            variant="primary"
            statSubtitle={L.facturado}
            statTitle={renderValue(summary?.total_facturado_fc)}
            statIconName="fas fa-file-invoice-dollar"
            statIconColor="bg-twilight-indigo-500"
          />

          <CardStats
            collapsed={collapsed}
            variant="danger"
            statSubtitle={L.nc}
            statTitle={renderValue(summary?.total_notas_credito_nc)}
            statIconName="fas fa-arrow-down"
            statIconColor="bg-red-500"
          />

          <CardStats
            collapsed={collapsed}
            variant="accent"
            statSubtitle={L.nd}
            statTitle={renderValue(summary?.total_notas_debito_nd)}
            statIconName="fas fa-arrow-up"
            statIconColor="bg-pacific-blue-500"
          />

        </div>
      </div>
    </div>
  );
}